module.exports = __webpack_public_path__ + "img/mobile-app.102a9104.svg";